import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import BloggersServices from './blogServices';

export const GetBlogger = createAsyncThunk(
  'blogger/getBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.getUserBlogger(payload);
      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetSingleBlogger = createAsyncThunk(
  'blogger/getSingleBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.getSingleBlogger(payload);
      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const PostComment = createAsyncThunk(
  'blogger/postComment',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.createComment(payload);
      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);
